import React from "react";
import DocumentViewer from "components/DocumentViewer";

const TermsOfUsePage: React.FC = () => {
    return <DocumentViewer titleKey="pages.login.termsOfUse" documentType="terms" />;
};

export default TermsOfUsePage;


